import parsePhoneNumberFromString from "libphonenumber-js";
import * as Yup from "yup";
import moment from "moment";
// const onlyCharactersRegx = /^[aA-zZ\s]+$/;
const specialCharactersNotAllowedRegx = /^[a-zA-Z0-9\s]+$/;

const FLOW_TYPES = ["BOTCOPY", "SMS", "HYBRID"];

export const loginValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Please enter valid Email")
    .required("Email is required!"),
  password: Yup.string()
    .min(6, "Password min length 6 digits")
    .max(18, "Password is too long!")
    .required("Password is required!"),
});

export const createUserValidationSchema = Yup.object().shape({
  firstName: Yup.string()
    .required("First Name is required!")
    .label("First Name"),
  lastName: Yup.string().required("Last Name is required!").label("Last Name"),
  email: Yup.string()
    .email("Please enter valid Email")
    .required("Email is required!"),
  mobile: Yup.string()
    .label("Mobile is required!")
    .required()
    .test("is-valid-phone", "Mobile is invalid", (value) => {
      console.log("value", value);
      const number = parsePhoneNumberFromString(value);
      return number ? number.isValid() : false;
    }),
  roleId: Yup.string().required().label("Select Role"),
  locations: Yup.array().required().label("Locations"),
});

export const createBrandValidationSchema = Yup.object().shape({
  brandLogo: Yup.array()
    .min(1, "Empty Brand Logo or Image size was greater then 2 MB")
    .max(1, "Can not upload more than 1 Brand Logo"),
  brandName: Yup.string().required("Brand Name is required"),
  brandAddress: Yup.string().required("Address is required"),
  shortBrandName: Yup.string().required("Short Name is required"),
  userType: Yup.string().oneOf(
    ["new", "existing"],
    "User type must be either new or existing",
  ),
  ownerName: Yup.string().when("userType", {
    is: (value) => value === "new",
    then: () => Yup.string().required("Owner Name is required"),
    otherwise: () => Yup.string().nullable(),
  }),
  ownerEmail: Yup.string()
    .email()
    .when("userType", {
      is: (value) => value === "new",
      then: () => Yup.string().email().required("Owner Email is required"),
      otherwise: () => Yup.string().nullable(),
    }),
  ownerMobileNumber: Yup.string().when("userType", {
    is: (value) => value === "new",
    then: () =>
      Yup.string()
        .required("Owner Mobile is required")
        .test("is-valid-phone", "Phone number is invalid", (value) => {
          const number = parsePhoneNumberFromString(value);
          return number ? number.isValid() : false;
        }),
    otherwise: () => Yup.string().nullable(),
  }),
});

export const uploadImageValidationSchema = Yup.object().shape({
  brandLogo: Yup.array()
    .min(1, "Brand Logo is Required")
    .max(1, "can not upload more than 1 Brand Logo"),
});
export const createRolesValidationSchema = Yup.object().shape({
  title: Yup.string().required().label("Role Title"),
});

export const paymentGatewayValidationSchema = Yup.object().shape({
  // paymentGateway: Yup.string()
  //   .required("Payment Gateway is required")
  //   .label("paymentGateway"),
});

export const plivoNumberValidationSchema = Yup.object().shape({
  plivoNumber: Yup.number().required().label("plivoNumber"),
});

export const flowTypeValidationSchema = Yup.object().shape({
  flowType: Yup.array()
    .of(
      Yup.string()
        .oneOf(FLOW_TYPES, "Invalid Flow Type")
        .label("Flow Type Element"),
    )
    .label("Flow Type"),
});

export const createPlaceValidationSchema = Yup.object().shape({
  brandId: Yup.string().required().label("Brand"),
  google: Yup.object()
    .test(
      "has-address",
      "Address is required",
      (value) =>
        value &&
        typeof value.formatted_address === "string" &&
        value.formatted_address.trim().length > 0,
    )
    .required("Address is required")
    .label("Address"),
  parkingCode: Yup.string()
    .matches(
      specialCharactersNotAllowedRegx,
      "Please enter a valid Parking Code",
    )
    .required()
    .label("Parking Code"),
  lotName: Yup.string()
    .matches(specialCharactersNotAllowedRegx, "Please enter a valid Lot Name")
    .required()
    .label("Lot Name"),
  statementDescriptor: Yup.string()
    .max(20)
    .required()
    .label("Statement Descriptor"),
  spaces: Yup.number().required().label("Number of Spaces"),
});

export const createRateValidation = Yup.object().shape({
  rateType: Yup.string().required().label("Rate Type"),
  title: Yup.string().required().label("Title"),
  displayName: Yup.string()
    .when("rateType", {
      is: "Custom",
      then: () =>
        Yup.string()
          .required("Display Name is required when rateType is custom")
          .max(25, "Display name should be maximum 25 characters"),
    })
    .label("Display Name"),
  isFreeRate: Yup.boolean().required(),
  isPass: Yup.boolean().required(),
  amount: Yup.number()
    .when(
      [
        "isFreeRate",
        "secondStepValidation",
        "isRateOption",
        "isPermit",
        "rateType",
      ],
      {
        is: (
          isFreeRate,
          secondStepValidation,
          isRateOption,
          isPermit,
          rateType,
        ) =>
          !isFreeRate &&
          !secondStepValidation &&
          !isRateOption &&
          !isPermit &&
          rateType !== "Monthly" &&
          rateType !== "monthly",
        then: () =>
          Yup.number()
            .positive("Amount must be a positive value")
            .required("Amount is required"),
        otherwise: () =>
          Yup.number()
            .min(0, "Amount must be greater than or equal to 0")
            .required("Amount is required"),
      },
    )
    .label("Amount"),
  endTime: Yup.string()
    .when("timeType", {
      is: (timeType) => timeType === "Fixed End Time",
      otherwise: () => Yup.string().nullable(),
    })
    .test(
      "is-valid-time",
      "end time must be a valid time, please select from dropdown",
      (value) => {
        return value ? moment(value, "HH:mm", true).isValid() : false;
      },
    ),
  customStartDate: Yup.string()
    .when("timeType", {
      is: (timeType) => timeType === "Custom Duration",
      otherwise: () => Yup.string().nullable(),
    })
    .test(
      "is-valid-time",
      "end time must be a valid time, please select from dropdown",
      (value) => {
        return value !== null;
      },
    ),
  startDay: Yup.string().when("isPass", {
    is: true,
    then: () => Yup.string().required("Start Day is required"),
    otherwise: () => Yup.string().nullable(),
  }),
  startTime: Yup.string().when("isPass", {
    is: true,
    then: () => Yup.string().required("Start Time is required"),
    otherwise: () => Yup.string().nullable(),
  }),
});

export const createAssignRateValidation = Yup.object().shape({
  rateType: Yup.string().required().label("Rate Type"),
  startTime: Yup.string().required().label("Start Time"),
  endTime: Yup.number().required().label("End Time"),
  days: Yup.array().required().label("Days"),
});

export const createSlackValidation = Yup.object().shape({
  purpose: Yup.string().required().label("Select Purpose"),
  channelName: Yup.string().required().label("Channel Name"),
  workSpace: Yup.string().required().label("Work Space"),
  webhookURL: Yup.string().required().label("Webhook URL"),
});

export const updatePlaceSettingsValidationSchema = Yup.object().shape({
  statementDescriptor: Yup.string()
    .optional()
    .label("Statement Descriptor")
    .max(21),
  isDockCopyEnable: Yup.boolean().optional(),
  dockcopyBotId: Yup.string().optional().label("Dock Copy Bot ID"),

  subscriptionContract: Yup.object().shape({
    enabled: Yup.boolean().required(),

    document: Yup.string().when("enabled", {
      is: true,
      then: (schema) =>
        schema
          .required("Contract document URL is required")
          .url("Must be a valid URL"),
      otherwise: (schema) => schema.notRequired(),
    }),
  }),
});

export const updatePaymentFeeValidation = Yup.object().shape({
  tax: Yup.number()
    .typeError("Tax must be a number")
    .required()
    .label("Tax")
    .max(100, "Tax should be maximum 100 %"),
});

export const EditLicensePlateValidationSchema = Yup.lazy((values) =>
  Yup.object().shape({
    licensePlateNumber: Yup.string().required(
      "License Plate Number is required",
    ),
    price: values?.isFreeSubscription
      ? Yup.number().nullable().optional()
      : Yup.number().required("Price is required"),
  }),
);

const licensePlateSchema = Yup.object().shape({
  licensePlateNumber: Yup.string().required("License Plate Number is required"),
  price: Yup.number()
    // .positive("Price must be positive")
    .required("Price is required"),
});
const addLicensePlateSchema = Yup.object().shape({
  licensePlateNumber: Yup.string().required("License Plate Number is required"),
});

export const CreateSubscriptionValidationSchema = Yup.lazy((values) => {
  const isFree = values?.isFreeSubscription;
  const currentLicensePlateSchema = Yup.object().shape({
    licensePlateNumber: Yup.string().required(
      "License Plate Number is required",
    ),
    price: isFree
      ? Yup.number().nullable().optional()
      : Yup.number()
          .min(0, "Price must be greater than or equal to 0")
          .required("Price is required"),
  });

  return Yup.object()
    .shape({
      startDate: Yup.date().required("Start Date is required"),
      endDate: Yup.date()
        .min(Yup.ref("startDate"), "End Date can't be before Start Date")
        .required("End Date is required"),
      email: Yup.string().email("Please enter a valid Email"),
      mobile: Yup.string()
        .matches(/^[0-9]+$/, "Mobile must be only digits")
        .min(10, "Mobile min length is 10 digits")
        .max(15, "Mobile max length is 15 digits"),
      firstName: Yup.string().required("First Name is required"),
      lastName: Yup.string().required("Last Name is required"),
      licensePlate: Yup.array()
        .of(currentLicensePlateSchema)
        .min(1, "Please add at least one License Plate Number")
        .required("License Plate is required"),
    })
    .test(
      "email-or-mobile",
      "Either Email or Mobile is required",
      (value) => value.email || value.mobile,
    );
});

export const AddLicensePlateValidationSchema = Yup.lazy((values) =>
  Yup.object().shape({
    licensePlate: Yup.array()
      .of(addLicensePlateSchema)
      .min(1, "Please add at least one License Plate Number")
      .required("License Plate is required"),
  }),
);
export const UpdateLicensePlateValidationSchema = Yup.lazy((values) => {
  const isFree = values?.isFreeSubscription;
  const currentLicensePlateSchema = Yup.object().shape({
    licensePlateNumber: Yup.string().required(
      "License Plate Number is required",
    ),
    price: isFree
      ? Yup.number().nullable().optional()
      : Yup.number()
          .min(0, "Price must be greater than or equal to 0")
          .required("Price is required"),
  });
  return Yup.object().shape({
    licensePlate: Yup.array()
      .of(currentLicensePlateSchema)
      .min(1, "Please add at least one License Plate Number")
      .required("License Plate is required"),
  });
});

export const createPricingTierValidation = (isDefault) =>
  Yup.object().shape({
    ...(isDefault
      ? {
          serviceFee: Yup.number().required().label("Service Fee"),
          condition_on: Yup.string().required().label("Condition On"),
          condition_operator: Yup.string().required().label("Operator"),
          condition_value: Yup.number().required().label("Amount"),
        }
      : {
          serviceFee: Yup.number().required().label("Service Fee"),
          subscriptionServiceFee: Yup.number()
            .required()
            .label("Subscription Service Fee"),
        }),
  });

export const createPricingTierUpdateValidation = (isDefault) =>
  Yup.object().shape({
    ...(isDefault
      ? {
          serviceFee: Yup.number().required().label("Service Fee"),
          subscriptionServiceFee: Yup.number()
            .required()
            .label("Subscription Service Fee"),
        }
      : {
          serviceFee: Yup.number().required().label("Service Fee"),
          condition_on: Yup.string().required().label("Condition On"),
          condition_operator: Yup.string().required().label("Operator"),
          condition_value: Yup.number().required().label("Amount"),
        }),
  });

export const createAutomatedReportValidation = Yup.object()
  .shape({
    toEmail: Yup.string()
      .email("Please enter a valid Email")
      .required("Email is required!"),
    ccEmails: Yup.array()
      .of(Yup.string().email("Please enter valid Email"))
      .optional(),
    placeIds: Yup.array()
      .of(Yup.string().required("Place ID is required"))
      .min(1, "At least one place is required"),
    isDaily: Yup.boolean(),
    isMonthly: Yup.boolean(),
    isWeekly: Yup.boolean(),
    isTransaction: Yup.boolean(),
    isRefund: Yup.boolean(),
  })
  .test(
    "is-daily-or-monthly-required",
    'Either "Daily",  "Weekly" or "Monthly setting must be selected',
    function (values) {
      const { isDaily, isMonthly, isWeekly } = values;
      if (!isDaily && !isMonthly && !isWeekly) {
        return this.createError({
          path: "email_setting",
          message: this.message,
        });
      }
      return true;
    },
  )
  .test(
    "at-least-one-transaction-or-refund-required",
    'At least one of "Transaction" or "Refund" setting must be selected',
    function (values) {
      const { isTransaction, isRefund } = values;
      if (!isTransaction && !isRefund) {
        return this.createError({
          path: "transaction_or_refund",
          message: this.message,
        });
      }
      return true;
    },
  );

export const CreatePermitSchema = Yup.object().shape({
  email: Yup.string().email("Please enter a valid Email").optional(),
  // .required("Email is required"),
  phoneNo: Yup.string()
    .nullable()
    .test("is-valid-phone", "Phone no is invalid", (value) => {
      console.log("value", value);

      if (!value || value === "+") {
        return true;
      }
      const numberWithCountryCode = parsePhoneNumberFromString(value);
      const numberWithOutCountryCode = parsePhoneNumberFromString(value, "US");
      return (
        (numberWithCountryCode && numberWithCountryCode.isValid()) ||
        (numberWithOutCountryCode && numberWithOutCountryCode.isValid())
      );
    })
    .optional(),
  // .required("Phone no is required"),
  internalId: Yup.string().when("selectedPermitOption", {
    is: (selectedPermitOption) => selectedPermitOption?.displayUnitNumber,
    then: () => Yup.string().required("Unit number is required"),
    otherwise: () => Yup.string().nullable(),
  }),
  licensePlate: Yup.array()
    .of(
      Yup.string()
        .matches(
          /^[A-Za-z0-9]+$/,
          "License Plate must be alphanumeric with no spaces",
        )
        .required("License Plate is required"),
    )
    .min(1, "Please add at least one License Plate Number")
    .required("License Plate is required"),
  vehicleMake: Yup.string().optional(),
  vehicleModel: Yup.string().optional(),
  vehicleState: Yup.string().optional(),
  // vehicleMake: Yup.string().required("Vehicle Make is required"),
  // vehicleModel: Yup.string().required("Vehicle Model is required"),
  // vehicleState: Yup.string().required("Vehicle State is required")
});

export const updateBrandDefaultSettingsValidationSchema = Yup.object().shape({
  subscriptionStateTax: Yup.number()
    .min(0, "Tax must be at least 0")
    .max(100, "Please enter value under 100!")
    .required("Tax is required!"),
  subscriptionCityTax: Yup.number()
    .min(0, "City Tax must be at least 0")
    .max(100, "Please enter value under 100!")
    .required("City Tax is required!"),
  subscriptionCountyTax: Yup.number()
    .min(0, "County Tax must be at least 0")
    .max(100, "Please enter value under 100!")
    .required("County Tax is required!"),
  transientStateTax: Yup.number()
    .min(0, "Tax must be at least 0")
    .max(100, "Please enter value under 100!")
    .required("Tax is required!"),
  transientCityTax: Yup.number()
    .min(0, "City Tax must be at least 0")
    .max(100, "Please enter value under 100!")
    .required("City Tax is required!"),
  transientCountyTax: Yup.number()
    .min(0, "County Tax must be at least 0")
    .max(100, "Please enter value under 100!")
    .required("County Tax is required!"),
  paymentGatewayFeePercentage: Yup.number()
    .min(0, "Percentage must be at least 0")
    .max(100, "Please enter value under 100!")
    .required("Percentage is required!"),
  paymentGatewayFeeFixedCents: Yup.number()
    .min(0, "Fixed Cents must be at least 0")
    .max(100, "Please enter value under 100!")
    .required("Fixed Cents is required!"),
  dockRevenue: Yup.number()
    .min(0, "Dock Revenue must be at least 0")
    .max(100, "Please enter value under 100!")
    .required("Dock Revenue is required!"),
  subscriptionDockRevenue: Yup.number()
    .min(0, "Subscription Dock Revenue must be at least 0")
    .max(100, "Please enter value under 100!")
    .required("Subscription Dock Revenue is required!"),
  serviceFee: Yup.number()
    .min(0, "Service Fee must be at least 0")
    .max(100, "Please enter value under 100!")
    .required("Service Fee is required!"),
  subscriptionServiceFee: Yup.number()
    .min(0, "Subscription Service Fee must be at least 0")
    .max(100, "Please enter value under 100!")
    .required("Subscription Service Fee is required!"),
});
